export const Text = [
    "IStellar has proficient team of react developers with extensive experience in ReactJS/React Native development. Being a leading ReactJS/React Native Development Company, our expert team make use of latest tools and techniques to deliver outstanding web/mobile applications. With proven expertise in this development services, we are proficient in delivering the most complex and challenging React frontend and backend applications.",
    "We optimize and try to improve upon our builds with inputs from our clients and have efficiently internalized the scrum methodology in our development style. We update our knowledge by following the latest trends in React JS communities.",
   
]

export const Text1 = [
    "IStellar was one of the early adopters of this technology and we possess hands-on experience in tackling several complexities while developing applications on this innovative technology. Our developers have enough skill to deliver the highest quality ReactJS development services to the startups as well as enterprises. Having worked on challenging React Applications for diverse industries and type of organizations, we specialize at building complex React based Applications.",
    "With the access to the right development tools and the best libraries to develop React Applications, our team is well-equipped to build production-ready React JS applications. We follow secure and stable development practices using industry-standard tools that work equally well on all the platforms",
   
]
// export const Text2 = [
//     "Hire ReactJS developers from IStellar and Start working with us that can provide everything for your reactjs applications",
   
// ]

export const inlineAnchor = [
    {
        anchor: "Hire ReactJS developers",
        para2: "from IStellar and Start working with us that can provide everything for your reactjs applications"
    }
    ]

export const list1=[
   {
    ul: [
        {li: "VueJS development",
        path: "/services/vuejs-development"},
        {li: "AngularJS development",
        path: "/services/angular-development"},
        {li: "Angular development",
        path: "services/angular-development"},
        {li: "NodeJS API development",
        path: "/services/nodejs-development"},
        {li: "D3.JS Data Visualization",
        path: "/"},
        {li: "React Native Mobile App Development",
        path: "/services/reactjs-development"},
    ]
}
]

export const ReactCardData = [
    {
        icon: "quickIcon",
        title: "ReactJS Front-End Development",
        content: "Our developers highly skilled to deliver the highest quality ReactJS development services to the startups as well as enterprises. We provide development services that suit your business needs. we offer custom software development services and solutions for complex business scenarios that are flexible & cost effective.",
    }, {
        icon: "quickIcon",
        title: "ReactJS Application Development"
,       content: "The ReactJS specialists of IStellar develops mobile apps that work seamlessly with some dynamic features. We provide adequate enterprise level apps to our clients. We deliver highly scalable and SEO friendly apps. We offer immensely responsive apps.",
        
    }, {
        icon: "reliableSupportIcon",
        title: "ReactJS Migration",
        content: "Our team assist clients in smooth migration from existing platform to ReactJS, in order to fulfill their business needs.",
    
    }, {
        icon: "reliableSupportIcon",
        title: "ReactJS Package Development",
        content: "Our experts can customize Packages for you that can render additional features to your web app that extends the functionality of your web app.",
    
    }, {
        icon: "reliableSupportIcon",
        title: "Maintenance and Support Services",
        content: "We are providing ongoing ReactJS maintenance and support services to the clients, after delivery of the project.",
    
    }, {
        icon: "reliableSupportIcon",
        title: "ReactJS QA and Testing",
        content: "Our QA team puts in some reasonable efforts for the testing app. We ensure error-free and seamless functioning of your app.",
    
    },
    ]
export const ReactJsImg = [
        "ReactjsImg1",
        ]

export const ReactJSIm = [
        "ReactjsImg2",
        ]
export const ReactJS1 = [
        "Reactjs1",
        ]
export const ReactJS2 = [
        "Reactjs2",
        ]
            
export const ReactJS3 = [
        "Reactjs3",
        ]
export const ReactJS4 = [
        "Reactjs4",
        ]

